import { createSlice } from "@reduxjs/toolkit";
import { fetchDebtorReceiptRecord } from "./DebtorReceiptRecordThunk";

const initialState = {
  list: [],
  loading: false,
  filters: {
    filterType: "All",
    recordType: "without details",
    fromDate: null,
    toDate: null,
    customerId: null,
    locationId: null,
    userId: null,
  },
};

const debtorReceiptRecordSlice = createSlice({
  name: "debtorReceiptRecord",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetList: (state) => {
      state.list = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDebtorReceiptRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDebtorReceiptRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchDebtorReceiptRecord.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = debtorReceiptRecordSlice.actions;
export default debtorReceiptRecordSlice.reducer;
